import { HttpResponseError } from '@vista-digital/http-client';
export const getResponseErrorStatusCode = (error) => {
    if (error instanceof HttpResponseError) {
        return error.statusCode;
    }
    else {
        return undefined;
    }
};
//# sourceMappingURL=get-response-error-status-code.js.map